import React, { useRef } from 'react'
// import PropTypes from 'prop-types';
import DisplayCard from './DisplayCard'
import DisplaySubscription from './DisplaySubscription'
import { path } from 'ramda'
import { AllPayments, isPlus, plusSubHasCode, GiftCodeForm, SmsMeteredInfo } from '.'
import classNames from 'classnames'
import { isApp } from '../../common/ambient'
import { useCanShowExternalPurchaseLinks } from '../device/redux/useCanShowExternalPurchaseLinks'
import './ManageSubscriptions.less'

export default function ManageSubscriptions ({ user, userActions }) {
  const { canShowExternalPurchaseLinks } = useCanShowExternalPurchaseLinks()
  const userId = path(['info', '_id'], user)
  const subscribedWithCode = plusSubHasCode(user)
  const giftCodeFormRef = useRef()
  
  const handleCodeValidated = ({ code, productName, valid }) => {
    if (valid) {
      // Determine the tier based on the productName from the code
      const isTeamsCode = productName && /for-teams/.test(productName)
      const tier = isTeamsCode ? 'teams' : 'plus'
      
      // Open the PlusSubscriptionModal with the validated code and tier
      userActions.doModal({ 
        type: 'plus-subscription', 
        data: {
          code,
          stepTwo: true,
          redeemCode: true,
          tier
        }
      })
      
      // Reset the gift code form so user can try again if they close the modal
      if (giftCodeFormRef.current) {
        giftCodeFormRef.current.reset()
      }
    }
  }

  const handleCancelGiftCode = () => {
    if (giftCodeFormRef.current) {
      giftCodeFormRef.current.reset()
    }
  }

  const credit = path(['info', 'payments', 'balance'], user)

  return (
    <div className='payment-manage-subscriptions block'>
      {/* <h2>Manage Subscriptions</h2>
      <br /><br /> */}
      <h3 id="payment_details">Payment Details</h3>
      <p>This card will be used if you choose the auto-renew option for any of your subscriptions.</p>
      <DisplayCard user={user} />
      <AllPayments userId={userId} mode='file' />
      {credit > 0 && (
        <div className={classNames('credit-message')}>
          <p><b>Account credit: ${ (credit / 100).toFixed(2) }</b></p>
          <p>Your account credit is not refundable and comes from previous plan changes and will be automatically applied to future payments before charging your payment method.</p>
        </div>
      )}

      <h3>Gift Codes</h3>
      <p>Redeem AWN+ subscription gift code or Buy one for your family or friends.</p>

      {canShowExternalPurchaseLinks && !isApp() && (
        <div className='btns'>
          <a className='btn btn-primary' target='_blank' rel='noreferrer' href='https://ambientweather.com/awn-plus-annual-subscription'>Buy Gift Code</a>
        </div>
      )}

      {subscribedWithCode ? (
        <div className='gift-message'>
          <p>
            <b className='blue'>You already have a free AWN+ gift subscription</b><br/>
            You will be able to activate a new gift code after your current gift subscription expires.
          </p>
        </div>
      ) : (
      <div className='gift-code-section'>
        <p><b>Apply your gift code for 1 year FREE annual subscription.</b></p>
        <p>Depending on your gift code, we'll automatically activate either the AWN+ or AWN+ Teams plan.</p>
        <GiftCodeForm
          user={user}
          ref={giftCodeFormRef}
          onCodeValidated={handleCodeValidated}
          disabled={subscribedWithCode}
          onCancel={handleCancelGiftCode}
        />
      </div>
      )}

      <SmsMeteredInfo user={user} userActions={userActions} />

      <h3 id='subscriptions'>Your Subscriptions</h3>
      <p>Cancel your subscription at any time by turning off auto-renew.  You can turn auto-renew back on any time before the subscription expires.</p>
      <div className='subscription-list'>
        {/* {(hasCellularDevice(device) || (subs && (subs.length > 0))) ? <DisplaySubscription /> : "You currently have no subscriptions."} */}
        <DisplaySubscription />
      </div>

    </div>
  )
};

ManageSubscriptions.propTypes = {}
ManageSubscriptions.defaultProps = {}

ManageSubscriptions.displayName = 'ManageSubscriptions'
